<template>
  <el-tabs v-model="active" @tab-click="handleClick">
    <el-tab-pane label="缺货待回货" name="oosWaitReturn">
      <list ref="list" :categoryOptions="categoryOptions" :virtualWarehouses="virtualWarehouses" :tabType="0"/>
    </el-tab-pane>
    <el-tab-pane label="状态变更记录" name="statusUpdateRecord">
      <statusUpdateRecord ref="statusUpdateRecord" />
    </el-tab-pane>
  </el-tabs>
</template>

<script>
import API from '@/api'
import list from './components/list.vue'
import statusUpdateRecord from './components/statusUpdateRecord.vue'

export default {
  name: 'report_dynamicSales',
  components: {
    list, statusUpdateRecord
  },
  data() {
    return {
      active: 'oosWaitReturn',
      virtualWarehouses: [],
      categoryOptions: []
    }
  },
  created() {
    this.getVirtualWarehouseSelect()
    this.getCategoryList()
  },
  methods: {
    handleClick(tab) {
      if (tab.name === 'oosWaitReturn') {
        this.$refs.list.getKakaOutReturnSkuList()
      }
      if (tab.name === 'statusUpdateRecord') {
        this.$refs.statusUpdateRecord.getRecordList()
      }
    },
    getVirtualWarehouseSelect() {
      API.getVirtualWarehouseSelect().then((res) => {
        this.virtualWarehouses = res.data
      })
    },
    // 获取品类列表
    async getCategoryList() {
      let { data } = await API.getCategoryList({ pageNumber: 1, pageSize: 1000 })
      if (data && data.list.length) {
        this.deletechildList(data.list)
        this.categoryOptions = data.list
      }
    },
    deletechildList(arr) {
      // 删除最后一级为空的childList字段
      arr.forEach((item) => {
        if (!item.childList.length) {
          delete item.childList
        } else {
          this.deletechildList(item.childList)
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.el-tabs {
  height: 100%;
  padding: 12px;
  background-color: #fff;
  /deep/.el-tabs__content {
    overflow: auto;
    height: calc(100% - 54px);
    .el-tab-pane {
      height: 100%;
    }
  }
}
</style>
